import { defineMessages } from 'react-intl-next';

export default defineMessages({
	moreTabWithBadge: {
		id: 'navigation-kit-ui-tab-list.more-trigger.more-tab-with-badge',
		defaultMessage: 'More',
		description:
			'When the navigation links do not fit on the screen we show a "More [5]" tab which is a dropdown menu containing all the tabs that do not fit in the screen.',
	},
});
